
import Vue from 'vue';
import { FTProcessRow } from '@/models/FTProcessRow';
import { standardFunctions } from '@/helpers/standardFunctions';
import { numFormat } from '@/helpers/numFormat';

export default Vue.extend({
  props: {
    passedKey: { type: Number, default: -1 },
    ftProcessRow: FTProcessRow,
    argument: { type: Object, default: () => {}},
    parent: { type: Object, default: () => {}}
  },
  data(): any {
    return {
      tempVariable: ''
    }
  },
  computed: {
    numFormattedArgumentValue: function(): string | number {
      return numFormat(this.argument.value);
    }
  },
  mounted() {
    if(this.argument.type === 'quantity' && this.ftProcessRow[this.argument.value]) {
      this.tempVariable = standardFunctions['kgToSQM'](this.ftProcessRow[this.argument.value], this.ftProcessRow.goodsObject);
    }
  }
})
